export default __webpack_public_path__ + "assets/b5844bacc99cdd75924cc9327d90b0b2.eot";